export const version = "Beta 1.1.0";
export function formatDate(date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}
  export const ICON = {
  navigation:require('../../static/resources/icon/navigation.png'),
  historyWhite:require('../../static/resources/icon/history-white.png'),
  historyOriginal:require('../../static/resources/icon/history-original.png'),
  monitorRed:require('../../static/resources/icon/monitor-red.png'),
  monitorOriginal:require('../../static/resources/icon/monitor-original.png'),
  order:require('../../static/resources/icon/order.png'),
  setting:require('../../static/resources/icon/setting.png'),
  settingOther:require('../../static/resources/icon/setting-other.png'),
  pay:require('../../static/resources/icon/pay.png'),
  apps:require('../../static/resources/icon/apps.png'),
  appsOriginal:require('../../static/resources/icon/apps-original.png'),
  sim:require('../../static/resources/icon/sim.png'),
  simOriginal:require('../../static/resources/icon/sim-original.png'),
  fenceOriginal:require('../../static/resources/icon/fence-original.png'),
  deviceListOriginal:require('../../static/resources/icon/device-list-original.png'),
  alarmOriginal:require('../../static/resources/icon/alarm-original.png'),
  edit:require('../../static/resources/icon/edit.png'),
  editOriginal:require('../../static/resources/icon/edit-original.png'),
  unbindOriginal:require('../../static/resources/icon/unbind-original.png'),
  memberOriginal:require('../../static/resources/icon/member-original.png'),
  addOriginal:require('../../static/resources/icon/add.png'),
  userauth:require('../../static/resources/icon/userauth.png'),
  audio:require('../../static/resources/icon/audio.png'),
  sonic:require('../../static/resources/icon/sonic.png'),
  sonicGif:require('../../static/resources/icon/sonic.gif')
}
export function getDurationDesc(duration)
{
  if(!duration){
    return null;
  }

  let tu = 24 * 60 * 60 * 1000;
  let d = parseInt(duration / tu);
  duration %= tu;
  tu = 60 * 60 * 1000;
  let h = parseInt(duration / tu);
  duration %= tu;
  tu = 60 * 1000;
  let m = parseInt(duration / tu);
  duration %= tu;
  return (d>0?d + "天":"") + (h>0?h + "小时":"") + (m>0?m + "分钟":"");
}
export default {
  APP_ID:1,

}
